import { render, staticRenderFns } from "./ztSwitch.vue?vue&type=template&id=d2476662&scoped=true"
import script from "./ztSwitch.vue?vue&type=script&lang=js"
export * from "./ztSwitch.vue?vue&type=script&lang=js"
import style0 from "../../../../../src/styles/components/ztSwitch.css?vue&type=style&index=0&id=d2476662&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2476662",
  null
  
)

export default component.exports